module.exports = __webpack_public_path__ + "img/3.5076b143.png";